import {AnyEvent, JOB_COMPANY_UPDATED_EVENT, JobCompanyUpdatedEvent} from '../type';

export default function jobCompanyUpdated(payload: JobCompanyUpdatedEvent['payload']): AnyEvent {
  return {
    type: JOB_COMPANY_UPDATED_EVENT,
    payload,
  }
}